export default {"src":"/_next/static/media/project-logo-alexandra-grey.335f4539.svg","height":48,"width":99,"blurWidth":0,"blurHeight":0};